RivalIQ.module('state', function (state, App, Backbone, Marionette, $, _, moment) {

    'use strict';

    const timePeriods = state.timePeriods = new Backbone.Collection();

    const timePeriodTypes = timePeriods.types = RivalIQ.enums.timePeriod.type;
    const enums = RivalIQ.enums.timePeriod;

    (function () {

        const timePeriodDefinitions = {};

        timePeriodDefinitions[timePeriodTypes.NOT_AVAILABLE] = {
            id: timePeriodTypes.NOT_AVAILABLE,
            name: 'not_available',
            selectable: false,
            disabled: true,
            displayString: 'Not Available',
            description: 'Time period is not selectable in this view.',
            mainPeriodStart: moment.utc(0).add(1, 'days'),
            mainPeriodEnd: moment.utc(0).add(1, 'days'),
            comparePeriodStart: moment.utc(0),
            comparePeriodEnd: moment.utc(0)
        };

        timePeriodDefinitions[timePeriodTypes.TODAY] = {
            id: timePeriodTypes.TODAY,
            name: 'today',
            selectable: false,
            disabled: true,
            displayString: 'As of Today',
            description: 'Only the most recent version of this information is available.',
            mainPeriodStart: moment.utc(),
            mainPeriodEnd: moment.utc(),
            comparePeriodStart: moment.utc().subtract(1, 'days'),
            comparePeriodEnd: moment.utc().subtract(1, 'days')
        };

        timePeriodDefinitions[timePeriodTypes.LOADING] = {
            id: timePeriodTypes.LOADING,
            name: 'loading',
            selectable: false,
            disabled: true,
            displayString: 'Loading...',
            mainPeriodStart: moment.utc(0).add(1, 'days'),
            mainPeriodEnd: moment.utc(0).add(1, 'days'),
            comparePeriodStart: moment.utc(0),
            comparePeriodEnd: moment.utc(0)
        };

        timePeriodDefinitions[timePeriodTypes.YESTERDAY] = {
            id: timePeriodTypes.YESTERDAY,
            name: 'yesterday',
            displayString: 'Yesterday',
            periods: periodVals(enums.mainPeriodType.YESTERDAY),
            mainPeriodStart: moment.utc().subtract(1, 'days'),
            mainPeriodEnd: moment.utc().subtract(1, 'days'),
            comparePeriodStart: moment.utc().subtract(2, 'days'),
            comparePeriodEnd: moment.utc().subtract(2, 'days')
        };

        timePeriodDefinitions[timePeriodTypes.THIS_WEEK] = {
            id: timePeriodTypes.THIS_WEEK,
            name: 'this_week',
            displayString: 'This Week to Date',
            periods: periodVals(enums.mainPeriodType.THIS_WEEK),
            mainPeriodStart: moment.utc().startOf('week'),
            mainPeriodEnd: moment.utc(),
            comparePeriodStart: moment.utc().startOf('week').subtract(7, 'days'),
            comparePeriodEnd: moment.utc().subtract(7, 'days')
        };

        timePeriodDefinitions[timePeriodTypes.LAST_WEEK] = {
            id: timePeriodTypes.LAST_WEEK,
            name: 'last_week',
            displayString: 'Last Week',
            periods: periodVals(enums.mainPeriodType.LAST_WEEK),
            mainPeriodStart: moment.utc().startOf('week').subtract(1, 'week'),
            mainPeriodEnd: moment.utc().endOf('week').subtract(1, 'week'),
            comparePeriodStart: moment.utc().startOf('week').subtract(2, 'week'),
            comparePeriodEnd: moment.utc().endOf('week').subtract(2, 'week')
        };

        timePeriodDefinitions[timePeriodTypes.THIS_MONTH] = {
            id: timePeriodTypes.THIS_MONTH,
            name: 'this_month',
            displayString: 'This Month to Date',
            periods: periodVals(enums.mainPeriodType.THIS_MONTH),
            mainPeriodStart: moment.utc().startOf('month'),
            mainPeriodEnd: moment.utc(),
            comparePeriodStart: moment.utc().subtract(1, 'month').startOf('month'),
            comparePeriodEnd: moment.utc().subtract(1, 'month')
        };

        timePeriodDefinitions[timePeriodTypes.LAST_MONTH] = {
            id: timePeriodTypes.LAST_MONTH,
            name: 'last_month',
            displayString: 'Last Month',
            periods: periodVals(enums.mainPeriodType.LAST_MONTH),
            mainPeriodStart: moment.utc().subtract(1, 'month').startOf('month'),
            mainPeriodEnd: moment.utc().subtract(1, 'month').endOf('month'),
            comparePeriodStart: moment.utc().subtract(2, 'month').startOf('month'),
            comparePeriodEnd: moment.utc().subtract(2, 'month').endOf('month')
        };

        timePeriodDefinitions[timePeriodTypes.THIS_QUARTER] = {
            id: timePeriodTypes.THIS_QUARTER,
            name: 'this_quarter',
            displayString: 'This Quarter to Date',
            periods: periodVals(enums.mainPeriodType.THIS_QUARTER),
            mainPeriodStart: moment.utc().startOf('quarter'),
            mainPeriodEnd: moment.utc(),
            comparePeriodStart: moment.utc().subtract(1, 'quarter').startOf('quarter'),
            comparePeriodEnd: moment.utc().subtract(1, 'quarter')
        };

        timePeriodDefinitions[timePeriodTypes.LAST_QUARTER] = {
            id: timePeriodTypes.LAST_QUARTER,
            name: 'last_quarter',
            displayString: 'Last Quarter',
            periods: periodVals(enums.mainPeriodType.LAST_QUARTER),
            mainPeriodStart: moment.utc().subtract(1, 'quarter').startOf('quarter'),
            mainPeriodEnd: moment.utc().subtract(1, 'quarter').endOf('quarter'),
            comparePeriodStart: moment.utc().subtract(2, 'quarter').startOf('quarter'),
            comparePeriodEnd: moment.utc().subtract(2, 'quarter').endOf('quarter')
        };

        timePeriodDefinitions[timePeriodTypes.LAST_SEVEN_DAYS] = {
            id: timePeriodTypes.LAST_SEVEN_DAYS,
            name: 'last_7_days',
            displayString: 'Last 7 Days',
            periods: periodVals(enums.mainPeriodType.LAST_SEVEN_DAYS),
            mainPeriodStart: moment.utc().subtract(6, 'days'),
            mainPeriodEnd: moment.utc(),
            comparePeriodStart: moment.utc().subtract(13, 'days'),
            comparePeriodEnd: moment.utc().subtract(7, 'days')
        };

        timePeriodDefinitions[timePeriodTypes.LAST_THIRTY_DAYS] = {
            default: true,
            id: timePeriodTypes.LAST_THIRTY_DAYS,
            name: 'last_30_days',
            displayString: 'Last 30 Days',
            periods: periodVals(enums.mainPeriodType.LAST_THIRTY_DAYS),
            mainPeriodStart: moment.utc().subtract(29, 'days'),
            mainPeriodEnd: moment.utc(),
            comparePeriodStart: moment.utc().subtract(59, 'days'),
            comparePeriodEnd: moment.utc().subtract(30, 'days')
        };

        timePeriodDefinitions[timePeriodTypes.LAST_NINETY_DAYS] = {
            id: timePeriodTypes.LAST_NINETY_DAYS,
            name: 'last_90_days',
            displayString: 'Last 90 Days',
            periods: periodVals(enums.mainPeriodType.LAST_NINETY_DAYS),
            mainPeriodStart: moment.utc().subtract(89, 'days'),
            mainPeriodEnd: moment.utc(),
            comparePeriodStart: moment.utc().subtract(179, 'days'),
            comparePeriodEnd: moment.utc().subtract(90, 'days')
        };

        function periodVals(mainPeriod) {
            const periods = {};
            periods[enums.periodType.MAIN_PERIOD] = mainPeriod;
            periods[enums.periodType.COMPARE_PERIOD] = enums.comparePeriodType.PREVIOUS_PERIOD;

            return periods;
        }


        timePeriods.getDefinitionByType = function (type) {
            const result = timePeriodDefinitions[type];
            return result;
        };

        timePeriods.getStaticDefinitionByType = function (type) {
            return RivalIQ.utils.timePeriod.toStatic(timePeriodDefinitions[type]);
        };


        timePeriods.onLandscapeTimezoneChangeTimePeriod = function (landscapeState) {
            const prevTimezone = _.get(landscapeState, 'attributes.prevTimezone', landscapeState.changed.prevTimezone);
            timePeriods.updateTimePeriodForTimezone(null, true, prevTimezone);
        };

        timePeriods.updateTimePeriodForTimezone = function (timePeriod, useStateTimePeriod, prevTimezone) {
            const periodTypes = RivalIQ.enums.timePeriod.periodType;

            const timezone = RivalIQ.state.landscape.get('timezone') || RivalIQ.utils.timezone.getClientTimezoneString();
            timePeriod = useStateTimePeriod ? RivalIQ.state.view.get('timePeriod') : timePeriod;

            const mainTimePeriod = _.get(timePeriod, ['periods', periodTypes.MAIN_PERIOD], enums.mainPeriodType.CUSTOM);
            const compareTimePeriod = _.get(timePeriod, ['periods', periodTypes.COMPARE_PERIOD], enums.comparePeriodType.CUSTOM);
            const definition = RivalIQ.data.timePeriodDefinitions.get(periodTypes.MAIN_PERIOD, mainTimePeriod);
            let mainDates;
            let compareDates;
            let timePeriodUpdated = false;

            if (definition && !definition.get('editable')) {
                // make sure prefixed time periods cover the right days. ie Last 7 Days
                // starts today instead of the last time the page reloaded.
                // NOTE: getDates() returns localized times. So Last 7 Days will include
                // the current day in tz (ie tomorrow for Australian timezones)
                mainDates = definition.getDates();
                compareDates = RivalIQ.data.timePeriodDefinitions.get(periodTypes.COMPARE_PERIOD, compareTimePeriod).getDates(mainDates);
                timePeriodUpdated = true;
            } else {
                // for custom date ranges, push back the end date if it is in the future.
                // EX: moving from AWST(+08) -> PST(-08). If mainPeriodEnd is the last available
                // date and we move to a tz where that date is in the future, move back time period by one day
                const endOfToday = moment().tz(timezone).endOf('day');
                let mainPeriodEnd;
                if (!timePeriod.mainPeriodEnd.tz() && prevTimezone && prevTimezone !== timezone) {
                    mainPeriodEnd = moment(timePeriod.mainPeriodEnd.format('YYYY-MM-DDTHH:mm:ss')).tz(prevTimezone).endOf('day');
                } else {
                    mainPeriodEnd = timePeriod.mainPeriodEnd;
                }
                if (mainPeriodEnd.isAfter(endOfToday) && prevTimezone && prevTimezone !== timezone) {
                    const dateSpan = timePeriod.mainPeriodEnd.diff(timePeriod.mainPeriodStart, 'day');
                    mainDates = [endOfToday.clone().subtract(dateSpan, 'day').startOf('day'), endOfToday];
                    compareDates = RivalIQ.data.timePeriodDefinitions.get(periodTypes.COMPARE_PERIOD, compareTimePeriod).getDates(mainDates);
                    timePeriodUpdated = true;
                }
            }

            if (timePeriodUpdated) {
                timePeriod.mainPeriodStart = moment(mainDates[0].format('YYYY-MM-DDTHH:mm:ss'));
                timePeriod.mainPeriodEnd = moment(mainDates[1].format('YYYY-MM-DDTHH:mm:ss'));
                timePeriod.comparePeriodStart = moment(compareDates[0].format('YYYY-MM-DDTHH:mm:ss'));
                timePeriod.comparePeriodEnd = moment(compareDates[1].format('YYYY-MM-DDTHH:mm:ss'));

                if (useStateTimePeriod) {
                    RivalIQ.state.view.set('timePeriod', timePeriod);
                }
            }

            return timePeriod;
        };
    }());

    function augmentTimePeriodDefinition(definition) {

        const timePeriod = _.extend({}, definition, _.result(definition, 'augmentData'));
        timePeriod.mainPeriodDuration = timePeriod.mainPeriodEnd.diff(timePeriod.mainPeriodStart, 'days') + 1;
        timePeriod.comparePeriodDuration = timePeriod.comparePeriodEnd.diff(timePeriod.comparePeriodStart, 'days') + 1;
        return timePeriod;
    }

    // NOTE: hydrateTimeperiod modifies the object passed in; consider cloning the timePeriod before calling this function.
    const hydrateTimeperiod = _.memoize(function (timePeriod) {
        App.utils.timePeriod.rehydrate(timePeriod);
        return timePeriod;
    }, function (data) {
        return data.mainPeriodStart + data.mainPeriodEnd + data.comparePeriodStart + data.comparePeriodEnd;
    });

    /**
     * Deserializes a JSON time period.
     * @param data
     * @returns {*}
     */
    timePeriods.deserialize = function (data) {
        if (!data) {
            return undefined;
        }

        const timePeriod = hydrateTimeperiod(_.clone(data));
        timePeriod.dates = data.dates;
        _.each(['mainPeriodStart', 'mainPeriodEnd', 'comparePeriodStart', 'comparePeriodEnd'], function (prop) {
            timePeriod[prop] = timePeriod[prop].clone();
        });

        return timePeriod;
    };

    /**
     * Creates a single day time period for a given date with a one day duration.
     * @param date
     * @param selectable
     * @returns {*}
     */
    timePeriods.createForDate = function (date, selectable) {

        const sanitizedDate = moment(date);
        const sanitizedDateBefore = moment(date).subtract(1, 'days');

        return augmentTimePeriodDefinition({
            selectable: (selectable !== false),
            disabled: selectable === false,
            displayString: `As of ${sanitizedDate.format('MMMM D, YYYY')}`,
            description: 'We last updated this data on the date shown.',
            mainPeriodStart: sanitizedDate,
            mainPeriodEnd: sanitizedDate,
            comparePeriodStart: sanitizedDateBefore,
            comparePeriodEnd: sanitizedDateBefore
        });
    };

    timePeriods.createForPeriod = function (type, endDate) {
        const startDateFn = RivalIQ.enums.schedule.periodStart[type];

        const comparePeriodEnd = startDateFn(endDate).subtract(1, 'day');

        return augmentTimePeriodDefinition({
            id: type,
            name: type,
            displayString: type,
            mainPeriodStart: startDateFn(endDate),
            mainPeriodEnd: moment(endDate),
            comparePeriodStart: startDateFn(comparePeriodEnd),
            comparePeriodEnd: comparePeriodEnd
        });
    };

    timePeriods.getByType = function (type) {
        const definition = timePeriods.getDefinitionByType(type);
        return (definition ? augmentTimePeriodDefinition(definition) : null);
    };

    timePeriods.combinePeriods = function (timePeriod) {

        const combinedPeriod = _.defaults({
            mainPeriodStart: timePeriod.comparePeriodStart.clone()
        }, timePeriod);


        return combinedPeriod;
    };

    /**
     * Initializes time periods from settings properties.
     * @param timePeriods
     */
    function initializeTimePeriodsFromProperties(timePeriods) {

        // NOTE we want to filter out time periods that are not selectable from
        // the curated list even though they are technically well defined
        const defined = _.reduce(timePeriodTypes, function (memo, timePeriodType) {

            const definition = timePeriods.getDefinitionByType(timePeriodType);
            const timePeriod = (definition ? augmentTimePeriodDefinition(definition) : null);

            return (!timePeriod || timePeriod.selectable === false ? memo : memo.concat([timePeriod]));
        }, []);

        timePeriods.reset(defined, {
            silent: true
        });
    }

    (function () {

        let hasInitialized = false;

        timePeriods.initialize = function (properties) {

            if (hasInitialized) {

                throw 'not supported: time periods cannot be initialized more than once.';
            }

            initializeTimePeriodsFromProperties(this, properties);

            hasInitialized = true;
        };

    }());

}, window.moment);
